import { ChangeEvent, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { unwrapResult } from '@reduxjs/toolkit';
import { Tooltip } from '@mui/material';

import { errorNormalizer, validateEmail } from '../../shared/Helpers/functions';
import { CustomAlert, CustomButton, CustomInput } from '../../shared/uiComponents';

import { DispatchProperties, useSelector } from '../../redux/store';
import { requestEmailChange } from '../../redux/State/identitySlice/userSlice';
import { EditSvg } from '../../shared/Assets/svgIcons';

const ChangeEmailContent = ({ onClose }: { onClose: () => void }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const { userId } = useParams();
	const [newEmail, setNewEmail] = useState<string>('');
	const [error, setError] = useState<string>('');

	const onEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;
		setNewEmail(value);
		setError('');
	};

	const onEmailBlurHandler = () => {
		if (!validateEmail(newEmail)) {
			setError('Invalid email');

			return;
		}
		setError('');
	};

	const startChangeEmailHandler = () => {
		if (!newEmail || !userId) return;
		dispatch(
			requestEmailChange({
				newEmail,
				userId,
			}),
		)
			.then(unwrapResult)
			.then(() => {
				toast('Success');
				onClose();
			})
			.catch(errorNormalizer);
	};

	return (
		<div>
			<CustomInput
				label="New Email"
				value={newEmail}
				onChange={onEmailChange}
				className="marginBottom16"
				error={Boolean(error)}
				errorMessage={error}
				onBlur={onEmailBlurHandler}
			/>
			<CustomButton
				title="Send confirmation"
				onClick={startChangeEmailHandler}
				disabled={Boolean(error)}
				className="marginBottom16 marginTop16"
			/>
			<CustomButton buttonType="secondaryGray" title="Cancel" onClick={onClose} />
		</div>
	);
};

const ChangeEmail = () => {
	const [open, setOpen] = useState<boolean>(false);
	const isUpdating = useSelector((state) => state.identityUser.isUpdating);

	return (
		<>
			<Tooltip title="Change Email">
				<div className="marginTop32" onClick={() => setOpen(true)}>
					<EditSvg />
				</div>
			</Tooltip>
			<CustomAlert
				isBusy={isUpdating}
				title="Change email"
				open={open}
				onClose={() => setOpen(false)}
				Content={ChangeEmailContent}
			/>
		</>
	);
};

export default ChangeEmail;
